export default {
    patientData : "",
    patient_id : "",
    reportData : ""
};
